@reference "../../../styles/globals.css";

.openInNewTabButton {
  @apply absolute top-3 right-10;

  @apply cursor-pointer w-5 h-5 flex items-center justify-center;
  @apply text-destructive;
  @apply hover:bg-white hover:text-foreground;
}

.openInNewTabButton svg {
  @apply w-5 h-5;
}
